"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rosterFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
const roster_persona_factory_1 = require("./roster-persona.factory");
exports.rosterFactory = Factory.Sync.makeFactory({
    _links: [],
    created_at: Mocks.dates.date2000,
    id: Factory.each(i => uuid_1.v4()),
    name: 'Test Roster',
    originator_id: '2345',
    originator_system: 'Ngin',
    originator_type: 'roster',
    roster_personas: roster_persona_factory_1.rosterPersonaFactory.buildList(2),
    roster_type: null,
    state: null,
    team_id: Factory.each(i => uuid_1.v4()),
    updated_at: Mocks.dates.date2000,
});
